/**
 * Creates a composite key from domain and feature
 */
export var createCompositeKey = function (domain, feature) {
    return domain + "|" + feature;
};
//# sourceMappingURL=constants.js.map